export const Skins = {
  Default: "default",
  Bordered: "bordered",
} as const;

export const Theme = {
  Light: "light",
  Dark: "dark",
  System: "system",
} as const;

export const Layout = {
  Vertical: "vertical",
  Horizontal: "horizontal",
  Collapsed: "collapsed",
} as const;

export const Direction = {
  Ltr: "ltr",
  Rtl: "rtl",
} as const;
